import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@truefit/http-utils';
import { GameModel } from '../types';

export const useCopyToSimuliveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (sourceGameId: string) => {
      const { data } = await post<GameModel>(
        `/v1.0/games/${sourceGameId}/copy-simulive`,
        {},
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Games'] });
    },
  });
};
